import HttpClient from "../infra/HttpClient";

export default class BannerService {
	constructor(readonly httpClient: HttpClient, readonly baseUrl: string) {
	}

	async getBanners() {
		return this.httpClient.get(`${this.baseUrl}/banners`);
	}
}
